import React from 'react';
import PropTypes from 'prop-types';
import './save-btn.scss';

const SaveBtn = (props) =>  {
  const { disabled, saveText, cancelText, onSave, onCancel } = props;
  return (
    <div className="save-buttons">
      <button className="button save-btn" onClick={onSave}
        disabled={disabled}>{saveText}</button>
      <button className="button cancel-btn" onClick={onCancel} disabled={disabled}>{cancelText}</button>
    </div>
  );
}

SaveBtn.defaultProps = {
  disabled: false,
}

SaveBtn.propTypes = {
  disabled: PropTypes.bool,
  saveText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SaveBtn;


// WEBPACK FOOTER //
// ./src/components/Common/SaveBtn/index.js